import { useState } from 'react';
import { createUseTextLocalizer } from '../../../locale/createUseTextLocalizer';
import { useDirectSpeech } from '../../DirectSpeech/DirectSpeechProvider';
import bundle from '../NovaComponents-TiledLayout-gui-icu.properties';
const useTextLocalizer = createUseTextLocalizer(bundle);
export const useTiledLayoutState = props => {
  const localize = useTextLocalizer();
  const directSpeech = useDirectSpeech();
  const {
    initialSelectedTiles,
    getTileKey,
    selectionMode,
    allowDeselection,
    disableInteractiveMode
  } = props;
  const [selectedTiles, setSelectedTiles] = useState(initialSelectedTiles ?? new Set());
  const [currentSelectedTile, setCurrentSelectedTile] = useState();
  const onTileSelect = e => {
    // if no index was provided, just return
    if (e.index === undefined) return;
    const tileKey = getTileKey(e.index);
    const tileIndex = e.index;
    const ctrlKey = e.ctlKey;
    const shiftKey = e.shiftKey;
    const metaKey = e.metaKey;
    let selectionType = 'select';
    if (selectionMode === 'desktop' || selectionMode === 'multiple') {
      if (shiftKey) {
        selectionType = 'range';
      } else if (ctrlKey || metaKey) {
        selectionType = 'toggle';
      }
    }
    const isSelected = selectedTiles.has(tileKey);
    let newSelectedTiles;
    const disallowDeselection = selectionMode === 'desktop' && allowDeselection === false;
    switch (selectionMode) {
      case 'single':
        newSelectedTiles = new Set();
        // if the tile is selected and deselection is allowed,
        // deselect the tile
        if (isSelected) {
          if (!allowDeselection) return;
          setCurrentSelectedTile(undefined);
          directSpeech?.notify(localize('itemDeselected.msg'));
        } else {
          // otherwise select the tile
          newSelectedTiles.add(tileKey);
          setCurrentSelectedTile(tileIndex);
          directSpeech?.notify(localize('itemSelected.msg'));
        }
        break;
      case 'desktop':
      case 'multiple':
        if (selectionType === 'toggle') {
          newSelectedTiles = new Set(selectedTiles);
          // toggle the select state of node and keep other selected nodes as it is
          if (isSelected) {
            if (disallowDeselection && selectedTiles.size === 1) return; // Block last tile deselect if not allowed
            newSelectedTiles.delete(tileKey);
            setCurrentSelectedTile(undefined);
            directSpeech?.notify(localize('itemRemovedFromSelection.msg', {
              index: (tileIndex + 1).toString()
            }));
          } else {
            newSelectedTiles.add(tileKey);
            setCurrentSelectedTile(tileIndex);
            directSpeech?.notify(localize('itemAddedToSelection.msg', {
              index: (tileIndex + 1).toString()
            }));
          }
        } else if (selectionType === 'range') {
          // select the range of nodes starting from the last selected node
          let iStart = tileIndex;
          let iEnd = currentSelectedTile ?? iStart;
          if (iStart > iEnd) {
            [iStart, iEnd] = [iEnd, iStart];
          }
          newSelectedTiles = ctrlKey || e.selectionArea === 'checkbox' ? new Set(selectedTiles) : new Set();
          for (let i = iStart; i <= iEnd; i++) {
            newSelectedTiles.add(getTileKey(i));
          }
          const total = iEnd - iStart + 1;
          const selectionAnnouncement = localize('selectionRange.msg', {
            total: total.toString(),
            firstSelectedIndex: (iStart + 1).toString(),
            lastSelectedIndex: (iEnd + 1).toString()
          });
          directSpeech?.notify(selectionAnnouncement);
        } else {
          newSelectedTiles = e.selectionArea !== 'checkbox' ? new Set() : new Set(selectedTiles);
          if (isSelected && (selectedTiles.size === 1 && !disallowDeselection || e.selectionArea === 'checkbox')) {
            newSelectedTiles.delete(tileKey);
            setCurrentSelectedTile(undefined);
            directSpeech?.notify(localize('itemDeselected.msg'));
          } else {
            newSelectedTiles.add(tileKey);
            setCurrentSelectedTile(tileIndex);
            directSpeech?.notify(localize('itemSelected.msg'));
          }
        }
        break;
      default:
        break;
    }
    if (newSelectedTiles) {
      setSelectedTiles(newSelectedTiles);
      props.onSelect?.(newSelectedTiles, tileKey);
    }
  };
  return {
    getTileKey,
    selectedTiles,
    selectionMode,
    disableInteractiveMode,
    onTileSelect,
    setSelectedTiles,
    setCurrentSelectedTile
  };
};
//# sourceMappingURL=useTiledLayoutState.js.map